// Libs
import classNames from 'classnames/bind';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { IStatistic } from '~/utils/interface/statistics';
import { DEFAULT_NUMBER_ZERO } from '~/utils/constants/common';
import { formatDecimal } from '~/utils/helper/common';
// Styles, images, icons
import styles from './Statistic.module.scss';

type Props = {
  title: string;
  icon?: string;
  image?: string;
  data: IStatistic;
  onClickIcon?: () => void;
};

const cx = classNames.bind(styles);

const Statistic = (props: Props) => {
  //#region Destructuring Props
  const { title, icon, image, data, onClickIcon } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleClickIcon = () => {
    onClickIcon?.();
  };
  //#endregion Handle Function

  return (
    <Box
      id='statisticComponent'
      className={cx('container')}
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
      }}
    >
      <Box className={cx('viewHeader')}>
        <Box className={cx('title')}>{title}</Box>
        {icon && (
          <Box className={cx('icon')} onClick={handleClickIcon}>
            <img src={icon} alt={t('common_alt_img')} />
          </Box>
        )}
      </Box>
      <Box className={cx('content')}>
        {data?.quantity ? formatDecimal(data?.quantity) : DEFAULT_NUMBER_ZERO}
      </Box>
    </Box>
  );
};

export default Statistic;
